import React from 'react'
import VideoCard from '../../atoms/videoCard/videoCard'
import sophi from '../../../assets/images/learn/sofi.png'
import './downloadableLearn.scss'

function DownloadableLearn() {
  const pushDataLayer = (Label) => {
    try {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'Vive el Cole :: Descargables',
        action: 'Click',
        label: Label,
        value: '',
      })
    } catch (error) {
      console.log('Datalayer error:', error)
    }
  }

  return (
    <div className='f-downloadable-learn'>
      <div className='f-downloadable-learn__wrapper'>
        <div className='f-downloadable-learn__title'>
          <h2>Descargables</h2>
        </div>
        <div className='f-downloadable-learn__content'>
          <VideoCard
            onClick={() => {
              pushDataLayer('Guía "Estoy Creciendo" de Nosotras')
              window.open('https://assets.ctfassets.net/o65uf8qogksw/3tex5Q3BvtRKyrDh0g9oLi/3835207496f2ff83ca78e14920ae0762/folleto-auxilio-estoy-creciendo-peru.pdf')
            }}
            title={'Guía "Estoy Creciendo" de Nosotras'}
            text={
              'Descarga el folleto oficial de Vive el Cole, una guía con información útil y fácil de entender'
            }
            image={sophi}
            download
          />

        </div>
      </div>
    </div>
  )
}

export default DownloadableLearn
